import React, { useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";

function PromotionModal({ isOpen, onClose }) {
  const [showCouponInput, setShowCouponInput] = useState(false);
  const validCouponCodes = ["MMTFREE3MONTHS", "MMTPREMIUM123"];
  const [email, setEmail] = useState("");
  const [coupon, setCoupon] = useState("");
  const [isUnlocked, setIsUnlocked] = useState(false);

  const handleClose = () => {
    setEmail("");
    setCoupon("");
    setShowCouponInput(false);
    setIsUnlocked(false);
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!coupon.trim()) {
      alert("We will contact you with the trial coupon");
    } else {
      if (validCouponCodes.includes(coupon.trim())) {
        alert("Thank you for applying. Your account will be activated if registered.");
      } else {
        alert("Invalid coupon code. Please try again.");
        return;
      }
    }
    handleClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm"
      onClick={handleClose}
    >
      <div
        className="relative mx-4 w-full max-w-md overflow-hidden rounded-2xl bg-white border border-slate-200 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* 상단 블루 헤더 */}
        <div className="px-6 pt-6 pb-5" style={{ background: "linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 60%, #3b82f6 100%)" }}>
          <button
            className="absolute top-4 right-4 w-7 h-7 flex items-center justify-center rounded-full bg-white/20 text-white hover:bg-white/30 transition text-lg leading-none"
            onClick={handleClose}
          >
            &times;
          </button>

          <div
            className="flex items-center gap-2 cursor-pointer select-none"
            onMouseEnter={() => setIsUnlocked(true)}
            onMouseLeave={() => setIsUnlocked(false)}
          >
            <span className={`text-3xl transition-transform duration-300 ${isUnlocked ? "rotate-12 scale-110" : ""}`}>
              {isUnlocked ? "🔓" : "🔒"}
            </span>
            <h2 className="text-2xl font-black text-white tracking-wide">Unlock Premium</h2>
          </div>
          <p className="text-blue-100 text-sm mt-1">Get full access to all courses and AI features</p>
        </div>

        {/* 바디 */}
        <div className="px-6 py-5">
          {/* What You'll Get */}
          <h3 className="text-sm font-bold text-slate-500 uppercase tracking-widest mb-3">What You'll Get</h3>
          <ul className="space-y-2.5 mb-5">
            {[
              { title: "AI Virtual Tutor", desc: "Solve problems with the help of a virtual tutor" },
              { title: "AI Coordinator", desc: "Analyze your challenges with an AI" },
              { title: "AI Class Generator", desc: "Generate your own custom class" },
              { title: "Diverse Courses", desc: "Prepare for AP Calculus AB & BC" },
            ].map((item) => (
              <li key={item.title} className="flex items-start gap-2.5">
                <BsCheckCircleFill className="mt-0.5 flex-shrink-0 text-blue-500" size={15} />
                <span className="text-sm text-slate-600">
                  <strong className="text-slate-800">{item.title}</strong> — {item.desc}
                </span>
              </li>
            ))}
          </ul>

          {/* 폼 */}
          <form onSubmit={handleSubmit} className="space-y-3">
            <div>
              <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Your Email</label>
              <input
                type="email"
                placeholder="example@domain.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
              />
            </div>

            {!showCouponInput ? (
              <button
                type="button"
                onClick={() => setShowCouponInput(true)}
                className="w-full rounded-lg border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-600 hover:bg-blue-100 transition"
              >
                I have a coupon code
              </button>
            ) : (
              <div>
                <label className="block text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">Coupon Code</label>
                <input
                  type="text"
                  placeholder="COUPON2024"
                  value={coupon}
                  onChange={(e) => setCoupon(e.target.value)}
                  className="w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                />
              </div>
            )}

            <button
              type="submit"
              className="w-full rounded-lg bg-blue-600 px-4 py-2.5 text-sm font-bold text-white shadow-sm hover:bg-blue-500 transition hover:scale-[1.02] active:scale-100"
            >
              Apply & Get Access
            </button>
          </form>

          <p className="mt-4 text-center text-xs text-slate-400">
            Questions?{" "}
            <a href="mailto:angiek@mmtprep.com" className="font-semibold text-blue-600 hover:underline">
              angiek@mmtprep.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default PromotionModal;
